import { render, staticRenderFns } from "./CheckOverlappingAppointmentsModal.vue?vue&type=template&id=45c9bc3a&"
import script from "./CheckOverlappingAppointmentsModal.vue?vue&type=script&lang=ts&"
export * from "./CheckOverlappingAppointmentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports